import { csx } from '@vtex/admin-ui'

const styles = {
  modalTitle: csx({
    display: 'flex',
    alignItems: 'center',
    gap: '$space-3',

    svg: { color: '$warning' },
  }),
  modalContent: csx({ paddingTop: 0 }),
}

export default styles
